import http from '@/utils/http'

export function getCoins(params){
    return http.get('/coin',{params})
}
export function getCoinDetail(id){
    return http.get(`/coin/${id}`)
}
export function putCoin(id,data){
    return http.put(`/coin/${id}`,data)
}